import * as E from 'fp-ts/Either';
import * as t from 'io-ts'; // withFallback wraps a codec so decode errors / missing values produce
// `fallback` instead of failing the entire surrounding decode. Use this
// for optional fields where a downstream-service hiccup should NOT
// cascade into the whole query failing -- e.g. Atlas tags from the
// Member-tags resolver: if the Go resolver errors, the field comes
// back null and we'd rather render 0 chips than 500 the whole profile.

export var withFallback = function withFallback(c, fallback) {
  return new t.Type("WithFallback<".concat(c.name, ">"), c.is, function (u, ctx) {
    return u == null ? t.success(fallback) : E.fold(function () {
      return t.success(fallback);
    }, t.success)(c.validate(u, ctx));
  }, c.encode);
};